module.exports = __webpack_public_path__ + "img/lens-150-plus-02.02f4093b.png";